export default "__VITE_ASSET__BCNvnEBK__"